import { FlexProps, Image, ImageProps } from '@chakra-ui/react';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { FallbackImage } from '~/components/FallbackImage';
import { IIconProps } from '~/components/Icon';

interface Props extends ImageProps {
  fallbackImageProps?: FlexProps & {
    iconProps?: IIconProps;
  };
  trackId?: string;
}

export const ContentImage: React.FC<Props> = memo(
  ({ fallbackImageProps, trackId, ...props }) => {
    const ref = useRef<HTMLImageElement>(null);
    const [error, setError] = useState(false);

    const handleError = useCallback(() => {
      setError(true);
    }, []);

    useEffect(() => {
      if (!ref.current?.src) {
        setError(true);
      }
    }, [ref]);

    return error ? (
      <FallbackImage {...fallbackImageProps} />
    ) : (
      <Image track-id={trackId} {...props} ref={ref} onError={handleError} />
    );
  },
);
